var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mnemonic-badge",class:[
    `mnemonic-badge-${_vm.variant}`,
    {
      'mnemonic-badge-urgent': _vm.urgent
    }
  ],attrs:{"title":_vm.urgent && 'Urgente'}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n\n  "),(_vm.urgent)?_c('svg-loader',{attrs:{"src":"/static/images/icon-urgent-fast.svg"}}):_vm._e()],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }